<!-- src/components/ri3/companyVehicles/QuickKmhHistoryDialog.vue -->
<template>
  <v-dialog
    :value="value"
    max-width="820"
    persistent
    transition="dialog-bottom-transition"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('Historique kilométrage') }}</v-toolbar-title>
        <v-spacer />

        <!-- Kilométrage actuel -->
        <v-chip v-if="currentKmh !== null && currentKmh !== undefined" class="mr-3" color="accent" label>
          <v-icon left small>mdi-speedometer</v-icon>
          {{ $t('Actuel') }}: {{ formatNumber(currentKmh) }}
        </v-chip>

        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-skeleton-loader
          v-if="loading"
          type="list-item, list-item, list-item"
          class="mb-3"
        />

        <template v-else>
          <v-alert
            v-if="!rows.length"
            type="secondary"
            dense
            outlined
            class="mb-3"
          >
            {{ $t('Aucun kilométrage enregistré pour ce véhicule.') }}
          </v-alert>

          <!-- Desktop : data-table -->
          <v-data-table
            v-if="$vuetify.breakpoint.mdAndUp"
            :headers="headers"
            :items="rows"
            disable-pagination
            hide-default-footer
            class="elevation-1"
          >
            <template #item.created_at="{ item }">
              {{ toDatetime(item.created_at) }}
            </template>
            <template #item.kmh="{ item }">
              <b>{{ formatNumber(item.kmh) }}</b>
            </template>
            <template #item.location="{ item }">
              {{ item.location || '—' }}
            </template>
          </v-data-table>

          <!-- Mobile : cartes -->
          <div v-else>
            <v-card
              v-for="r in rows"
              :key="r.transaction_number || r.created_at"
              class="mb-2"
              outlined
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    {{ formatNumber(r.kmh) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ formatDate(r.created_at) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="r.location">
                    <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
                    {{ r.location }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="r.transaction_number">
                  <v-chip small>{{ r.transaction_number }}</v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-card>
          </div>
        </template>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="$emit('input', false)">{{ $t('Fermer') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CompanyVehiclesService from "@/services/CompanyVehiclesService"
import { toDate, toDatetime } from "@/utils/datetime";


export default {
  name: "QuickKmhHistoryDialog",
  props: {
    value: { type: Boolean, default: false },       // v-model
    vehicle: { type: Object, default: () => ({}) }, // véhicule courant
    limit: { type: Number, default: 100 }           // optionnel: limiter les entrées
  },
  data() {
    return {
      loading: false,
      rows: [],
      currentKmh: null,
      headers: [
        { text: this.$t("Date"), value: "created_at" },
        { text: this.$t("Station"), value: "location" },
        { text: this.$t("Kilométrage"), value: "kmh" },
        { text: this.$t("Transaction"), value: "transaction_number" },
      ],
    }
  },
  watch: {
    value: {
      immediate: true,
      async handler(open) {
        if (open && this.vehicle?.id) {
          await this.fetchData()
        }
      }
    }
  },
  methods: {
    toDatetime,
    async fetchData() {
      this.loading = true
      try {
        const data = await CompanyVehiclesService.getKmhHistory(this, this.vehicle.id, { limit: this.limit })
        this.currentKmh = data?.current_kmh ?? this.vehicle?.kmh ?? null
        // backend renvoie déjà trié en -created_at
        this.rows = Array.isArray(data?.results) ? data.results : []
      } catch (e) {
        this.$store.commit("app/message", { msg: this.$t("messages.error.unknown"), color: "error" })
      } finally {
        this.loading = false
      }
    },
    formatDate(dt) {
      try { return toDate(dt).format("DD/MM/YYYY HH:mm") } catch { return dt }
    },
    formatNumber(value) {
      if (value === null || value === undefined) return "—"
      const n = Number(value) || 0
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
  }
}
</script>
